module.exports = __webpack_public_path__ + "img/ast.82c5086f.svg";